import { PagedRequestDto } from './../paged-request.model';
export interface CorporatePositionsCorporationParameters extends PagedRequestDto {
  isActive?: boolean;
}
